// import QuickView from './product/quickView';
// import ProductBox from './product/productBox';
// import QuickBuyModal from './product/quickBuyModal';

import ProductHelpers from './product/base';
import initHeroBanner from './search/heroBanner';
import initRefineBarComponent from './search/refineBarComponent';
import initSlotActivator from './search/slotActivator';
import initSpecialRefinement from './search/specialRefinementBar';

document.addEventListener('DOMContentLoaded', () => {
    // processInclude(require('./search/search'));
    // const p = new ProductBox();
    // p.run();
    // const quickView = new QuickView();
    // quickView.run();
    // const quickBuyModal = new QuickBuyModal();
    // quickBuyModal.run();
    initHeroBanner();
    initRefineBarComponent();
    initSlotActivator();
    initSpecialRefinement();
    ProductHelpers.run();
    showWhiteShadowOnScroll();
});

$(document).ready(function () {
    const expandableContainer = $('.ca-expandable');
    const expandButton = $('.ca-toggle-button-expand');
    const collapseButton = $('.ca-toggle-button-collapse');
    const toggleButtonContainer = $('.ca-toggle-button-container');
    const paddingOffset = parseInt($('.jsExpandPaddingReference').css('padding-bottom')) || 0;
    const referenceElementHeight = parseInt($('.jsExpandReference').outerHeight()) + paddingOffset;
    const expandedClass = 'ca-expanded';

    expandableContainer.css('max-height', referenceElementHeight + 'px');

    if (referenceElementHeight && expandableContainer.length > 0 && expandableContainer[0].scrollHeight > referenceElementHeight) {
        toggleButtonContainer.show();
    } else {
        toggleButtonContainer.hide();
    }

    expandButton.on('click', function () {
        const fullHeight = expandableContainer[0].scrollHeight;
        expandableContainer.addClass(expandedClass);
        expandableContainer.css('max-height', fullHeight + 'px');
        expandButton.hide();
        collapseButton.show();
    });

    collapseButton.on('click', function () {
        expandableContainer.removeClass(expandedClass);
        expandableContainer.css('max-height', referenceElementHeight + 'px');
        collapseButton.hide();
        expandButton.show();
    });

    const refinementContainer = document.querySelector('.js-plp-specialRef');
    const isRefinementScrollable = refinementContainer.scrollWidth > refinementContainer.clientWidth;
    if (isRefinementScrollable) {
        $('.js-white-shadow-right-big').addClass('js-shadow-on');
    }
    refinementContainer.addEventListener('scroll', throttle(() => {
        disableArrowOnEdge();
    }, 500));

    refinementContainer.addEventListener('mouseover', throttle(() => {
        $('.js-plp-specialRef-scrollArrow_left').addClass('js-arrows_on');
        $('.js-plp-specialRef-scrollArrow_right').addClass('js-arrows_on');
        refinementArrowScrolls();
        disableArrowOnEdge();
    }, 250));
    refinementContainer.addEventListener('mouseleave', throttle(() => {
        $('.js-plp-specialRef-scrollArrow_left').removeClass('js-arrows_on');
        $('.js-plp-specialRef-scrollArrow_right').removeClass('js-arrows_on');
        $('.js-plp-specialRef-scrollArrow_left').removeClass('js-arrows_disabled');
        $('.js-plp-specialRef-scrollArrow_right').removeClass('js-arrows_disabled');
    }, 250));
    window.addEventListener('resize', throttle(() => {
        $('.js-plp-specialRef-scrollArrow_left').removeClass('js-arrows_on');
        $('.js-plp-specialRef-scrollArrow_right').removeClass('js-arrows_on');
    }, 500));
});

$(document).ready(function () {
    const faqSection = $('div.ca-faq-section');

    if (faqSection && faqSection.length) {
        const faqData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': []
        };

        faqSection.find('div.accordion').find('div.accordion-item').each(function () {
            const question = $(this).find('h3.accordion-title').text();
            let answer = '';
            $(this).find('div.accordion-content').find('p').each(function () {
                answer += $(this).text() + ' ';
            });

            faqData.mainEntity.push({
                '@type': 'Question',
                'name': question,
                'acceptedAnswer': {
                    '@type': 'Answer',
                    'text': answer.trim()
                }
            });
        });

        const scriptTag = $('<script>', {
            type: 'application/ld+json',
            text: JSON.stringify(faqData)
        });

        $('head').append(scriptTag);
    }
});

function refinementArrowScrolls () {
    const refinementContainer = document.querySelector('.js-plp-specialRef');
    const isRefinementScrollable = refinementContainer.scrollWidth > refinementContainer.clientWidth;
    if (!isRefinementScrollable) {
        $('.js-plp-specialRef-scrollArrow_left').removeClass('js-arrows_on');
        $('.js-plp-specialRef-scrollArrow_right').removeClass('js-arrows_on');
        return;
    }
    const leftArrow = document.querySelector('.js-plp-specialRef-scrollArrow_left');
    const rightArrow = document.querySelector('.js-plp-specialRef-scrollArrow_right');
    const scrollAmount = 200;
    leftArrow.addEventListener('click', () => {
        refinementContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
        refinementContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
};

function disableArrowOnEdge () {
    const refinementContainer = document.querySelector('.js-plp-specialRef');
    const isRefinementScrollable = refinementContainer.scrollWidth > refinementContainer.clientWidth;
    if (!isRefinementScrollable) {
        return;
    }
    const refinementScrollLeft = refinementContainer.scrollLeft;
    const maxrefinementScrollLeft = refinementContainer.scrollWidth - refinementContainer.clientWidth;
    if (refinementScrollLeft <= 0) {
        $('.js-plp-specialRef-scrollArrow_left').addClass('js-arrows_disabled');
    } else if (refinementScrollLeft >= maxrefinementScrollLeft - 1) {
        $('.js-plp-specialRef-scrollArrow_right').addClass('js-arrows_disabled');
    } else {
        $('.js-plp-specialRef-scrollArrow_left').removeClass('js-arrows_disabled');
        $('.js-plp-specialRef-scrollArrow_right').removeClass('js-arrows_disabled');
    }
}

function throttle (func, delay) {
    let time = 0;

    return function (...args) {
        let now = Date.now();

        if (now - time >= delay) {
            func.apply(this, args);
            time = now;
        }
    };
};